import { SubmitFormData } from "@/interfaces";
import { FullAddress } from "@/utils/googleMaps";
import { DeviceInfo } from "@/utils/info";
import axios from "axios";

export interface ProductInfo {
  app: string;
  birthRegister: string;
  companyCode: string;
  count: number;
  digit: string;
  firstCheck: string;
  format: string;
  lastCheck: string;
  lineRegister: string;
  logStatus: string;
  nameRegister: string;
  pattern: string;
  points: number;
  productCode: string;
  productImage: string;
  productName: string;
  productShortName: string;
  qrcode: string;
  query: string;
  register: string;
  royalty: string;
  serial: string;
  serialStatus: string;
  sexRegister: string;
  splitQrcode: number;
  token?: string;
  urlMessage: string;
  urlRoyalty: string;
}

export const scanQRCode = (
  qrcode: string,
  address: FullAddress | null,
  deviceInfo: DeviceInfo
) => {
  return axios.post<ProductInfo>("https://thitipong.com/api/scuse", {
    qrcode,
    ...address,
    ...deviceInfo
  });
};

export const submitFormPost = (formData: SubmitFormData, token: string) => {
  return axios.post<SubmitFormData>(
    "https://thitipong.com/api/register",
    formData,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
};
